import axios from 'axios';
import constants from '../../util/constants';
const LICHESS_BASE_URL = constants.LICHESS_BASE_URL;

export const connectToEventStream = (controller) => async (dispatch) => {
  const lichesstoken = localStorage.getItem('LichessIdToken');

  const response = await axios.get(`${LICHESS_BASE_URL}/api/stream/event`, {
    headers: { 
      'Authorization': lichesstoken,
      'Accept': 'text/event-stream' // Request server-sent events stream
    },
    responseType: 'stream',
    adapter: 'fetch',
    timeout: 0, // Disable timeout to keep connection open indefinitely,
    signal: controller.signal
  });
  const stream = response.data;
  const reader = stream.pipeThrough(new TextDecoderStream()).getReader();
  let lastEntry = '';
  while (true) {
    const { value } = await reader.read();
    const entries = value?.split('\n');
    if (!entries) {
      return;
    }
    for (const entry of entries) {
      try {
        const data = JSON.parse(lastEntry);
        lastEntry = '';
        switch (data.type) {
          case 'gameStart':
            dispatch({ type: 'GAME_STARTED', payload: data.game });
            break;
          default:
            break;
        }
      } catch (_err) {
        
        lastEntry += entry;
      }
    }
  }
};

export const connectToGameStream = (gameId) => async (dispatch) => {
  const lichesstoken = localStorage.getItem('LichessIdToken');

  // console.log('game streaming')
  const response = await axios.get(`${LICHESS_BASE_URL}/api/board/game/stream/${gameId}`, {
    headers: { 
      'Authorization': lichesstoken,
      'Accept': 'text/event-stream' // Request server-sent events stream
    },
    responseType: 'stream',
    adapter: 'fetch',
    timeout: 0 // Disable timeout to keep connection open indefinitely
  });
  const stream = response.data;
  const reader = stream.pipeThrough(new TextDecoderStream()).getReader();
  let lastEntry = '';
  while (true) {
    const { value } = await reader.read();
    const entries = value?.split('\n');
    if (!entries) {
      return;
    }
    for (const entry of entries) {
      try {
        const data = JSON.parse(lastEntry);
        lastEntry = '';
        
        switch (data.type) {
          case 'gameState':
            dispatch({ type: 'GAME_STATE', payload: data });
            break;
          case 'gameFull':
            dispatch({ type: 'GAME_FULL', payload: data });
            break;
          default:
            break;
        }
      } catch (_err) {
        
        lastEntry += entry;
      }
    }
  }
};